import { render, staticRenderFns } from "./Faq.vue?vue&type=template&id=13913f00&scoped=true"
import script from "./Faq.js?vue&type=script&lang=js&external"
export * from "./Faq.js?vue&type=script&lang=js&external"
import style0 from "./Faq.scss?vue&type=style&index=0&id=13913f00&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13913f00",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotTitle: require('/home/runner/_work/app-hotmart-digital-learning/app-hotmart-digital-learning/components/Atoms/Title/Title.vue').default,HotAccordionItem: require('/home/runner/_work/app-hotmart-digital-learning/app-hotmart-digital-learning/components/Molecules/AccordionItem/AccordionItem.vue').default,HotAccordion: require('/home/runner/_work/app-hotmart-digital-learning/app-hotmart-digital-learning/components/Molecules/Accordion/Accordion.vue').default})
